export enum LogSeverity {
	Emerg,
	Security,
	Alert,
	Crit,
	Err,
	Warn,
	Session,
	Notice,
	Info,
	Debug,
}
